import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './contact-access.css'

const ContactAccess = (props) => {
  return (
    <div className="contact-access-container1">
      <Helmet>
        <title>Contact-Access - Swift Luminous Porcupine</title>
        <meta
          property="og:title"
          content="Contact-Access - Swift Luminous Porcupine"
        />
        <link
          rel="canonical"
          href="https://swift-luminous-porcupine-7pvu8b.teleporthq.app/contact-access"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="contact---access-hero-section">
        <div className="contact---access-hero-background">
          <img
            alt="Stratix Group Corporate Headquarters"
            src="https://images.pexels.com/photos/17292193/pexels-photo-17292193.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="hero-image"
          />
          <div className="contact---access-hero-overlay"></div>
        </div>
        <div className="contact---access-hero-container">
          <div className="contact---access-hero-content">
            <h1 className="hero-title">Skilled. Trusted. Execution.</h1>
            <p className="hero-subtitle">
              Stratix Group provides a centralized hub for professional
              construction services. Connect with our specialized divisions for
              residential, commercial, and government projects.
            </p>
            <div className="contact---access-hero-cta-group">
              <a href="#division-access">
                <div className="btn-lg btn btn-primary">
                  <span>Division Inquiries</span>
                </div>
              </a>
              <a href="#general-contact">
                <div className="btn-outline btn-lg btn">
                  <span>General Support</span>
                </div>
              </a>
            </div>
          </div>
          <div className="hero-secondary">
            <div className="hero-info-grid">
              <div className="hero-info-card">
                <div className="hero-icon-wrapper">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <div className="hero-info-text">
                  <span className="hero-info-label">Main Corporate Line</span>
                  <span className="hero-info-value">800.STX.GROUP</span>
                </div>
              </div>
              <div className="hero-info-card">
                <div className="hero-icon-wrapper">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                      <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                    </g>
                  </svg>
                </div>
                <div className="hero-info-text">
                  <span className="hero-info-label">Secure Inquiries</span>
                  <span className="hero-info-value">
                    compliance@stratix.com
                  </span>
                </div>
              </div>
              <div className="hero-info-card">
                <div className="hero-icon-wrapper">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <div className="hero-info-text">
                  <span className="hero-info-label">Verification</span>
                  <span className="hero-info-value">Licensed &amp; Bonded</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="division-access" className="division-section">
        <div className="division-container">
          <div className="division-header">
            <h2 className="section-title">Operating Companies</h2>
            <p className="section-subtitle">
              Direct communication paths for our specialized trade and general
              construction divisions.
            </p>
          </div>
          <div className="division-grid">
            <div className="division-card">
              <div className="division-card-inner">
                <h3 className="division-name">STX General Contracting</h3>
                <p className="section-content">
                  Comprehensive residential and commercial management.
                </p>
                <div className="division-contact-list">
                  <div className="division-contact-item">
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>800.STX.GEN1</span>
                  </div>
                  <div className="division-contact-item">
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                      </g>
                    </svg>
                    <span>gc@stratix.com</span>
                  </div>
                </div>
                <div className="division-actions">
                  <button
                    data-division="General Contracting"
                    className="btn open-form-btn btn-sm btn-primary"
                  >
                    Inquiry Form
                  </button>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Visit Website</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="division-card">
              <div className="division-card-inner">
                <h3 className="division-name">STX Electrical Solutions</h3>
                <p className="section-content">
                  Industrial and commercial electrical infrastructure.
                </p>
                <div className="division-contact-list">
                  <div className="division-contact-item">
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>800.STX.ELEC</span>
                  </div>
                  <div className="division-contact-item">
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                      </g>
                    </svg>
                    <span>electric@stratix.com</span>
                  </div>
                </div>
                <div className="division-actions">
                  <button
                    data-division="Electrical"
                    className="btn open-form-btn btn-sm btn-primary"
                  >
                    Inquiry Form
                  </button>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Visit Website</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="division-card">
              <div className="division-card-inner">
                <h3 className="division-name">STX HVAC &amp; Mechanical</h3>
                <p className="section-content">
                  Climate control systems for municipal buildings.
                </p>
                <div className="division-contact-list">
                  <div className="division-contact-item">
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>800.STX.HVAC</span>
                  </div>
                  <div className="division-contact-item">
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                      </g>
                    </svg>
                    <span>hvac@stratix.com</span>
                  </div>
                </div>
                <div className="division-actions">
                  <button
                    data-division="HVAC"
                    className="btn open-form-btn btn-sm btn-primary"
                  >
                    Inquiry Form
                  </button>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Visit Website</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="division-card">
              <div className="division-card-inner">
                <h3 className="division-name">STX Roofing &amp; Building</h3>
                <p className="section-content">
                  Specialized envelope and roofing systems.
                </p>
                <div className="division-contact-list">
                  <div className="division-contact-item">
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>800.STX.ROOF</span>
                  </div>
                  <div className="division-contact-item">
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                      </g>
                    </svg>
                    <span>roofing@stratix.com</span>
                  </div>
                </div>
                <div className="division-actions">
                  <button
                    data-division="Roofing"
                    className="btn open-form-btn btn-sm btn-primary"
                  >
                    Inquiry Form
                  </button>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Visit Website</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="division-card">
              <div className="division-card-inner">
                <h3 className="division-name">STX Plumbing &amp; Piping</h3>
                <p className="section-content">
                  Industrial piping and municipal water systems.
                </p>
                <div className="division-contact-list">
                  <div className="division-contact-item">
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>800.STX.PIPE</span>
                  </div>
                  <div className="division-contact-item">
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                      </g>
                    </svg>
                    <span>plumbing@stratix.com</span>
                  </div>
                </div>
                <div className="division-actions">
                  <button
                    data-division="Plumbing"
                    className="btn open-form-btn btn-sm btn-primary"
                  >
                    Inquiry Form
                  </button>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Visit Website</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="division-card">
              <div className="division-card-inner">
                <h3 className="division-name">STX Civil Engineering</h3>
                <p className="section-content">
                  Heavy civil and infrastructure development.
                </p>
                <div className="division-contact-list">
                  <div className="division-contact-item">
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>800.STX.CIVIL</span>
                  </div>
                  <div className="division-contact-item">
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                      </g>
                    </svg>
                    <span>civil@stratix.com</span>
                  </div>
                </div>
                <div className="division-actions">
                  <button
                    data-division="Civil"
                    className="btn open-form-btn btn-sm btn-primary"
                  >
                    Inquiry Form
                  </button>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Visit Website</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="location-section">
        <div className="location-container">
          <div className="location-grid">
            <div className="location-info">
              <h2 className="section-title">Regional Headquarters</h2>
              <p className="section-content">
                Stratix Group maintains strategic operational centers to serve
                major metropolitan areas and government hubs.
              </p>
              <div className="location-details">
                <div className="location-item">
                  <div className="location-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                        <circle r="3" cx="12" cy="10"></circle>
                      </g>
                    </svg>
                  </div>
                  <div className="location-text">
                    <h4 className="location-name">Corporate HQ</h4>
                    <p className="section-content">
                      <span>1200 Enterprise Way, Suite 400</span>
                      <br></br>
                    </p>
                  </div>
                </div>
                <div className="location-item">
                  <div className="location-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M12 6v6l4 2"></path>
                        <circle r="10" cx="12" cy="12"></circle>
                      </g>
                    </svg>
                  </div>
                  <div className="location-text">
                    <h4 className="location-name">Operating Hours</h4>
                    <p className="section-content">
                      <span>Monday - Friday: 07:00 - 18:00 CST</span>
                      <br></br>
                    </p>
                  </div>
                </div>
                <div className="location-item">
                  <div className="location-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                        <path d="m9 12l2 2l4-4"></path>
                      </g>
                    </svg>
                  </div>
                  <div className="location-text">
                    <h4 className="location-name">Coverage Area</h4>
                    <p className="section-content">
                      <span>Licensed in TX, LA, OK, and FL.</span>
                      <br></br>
                    </p>
                  </div>
                </div>
              </div>
              <a href="#">
                <div className="btn btn-secondary">
                  <span>View All Locations</span>
                </div>
              </a>
            </div>
            <div className="location-map-wrapper">
              <div className="location-map-placeholder">
                <img
                  alt="Regional Coverage Map"
                  src="https://images.pexels.com/photos/9405517/pexels-photo-9405517.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="location-map-img"
                />
                <div className="location-map-overlay">
                  <span className="location-badge">
                    Interactive Map Coming Soon
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact---access-process-section">
        <div className="process-container">
          <div className="process-header">
            <h2 className="section-title">Inquiry Triage &amp; Assignment</h2>
            <p className="section-subtitle">
              Our disciplined approach ensures your request is handled by the
              appropriate specialist division.
            </p>
          </div>
          <div className="process-stepper">
            <div className="process-step">
              <div className="process-step-number">
                <span>01</span>
              </div>
              <h4 className="process-step-title">Triage</h4>
              <p className="section-content">
                Inquiry is received by our corporate intake team and classified
                by project type.
              </p>
            </div>
            <div className="process-step">
              <div className="process-step-number">
                <span>02</span>
              </div>
              <h4 className="process-step-title">Assignment</h4>
              <p className="section-content">
                Project details are routed to the specific licensed operating
                company lead.
              </p>
            </div>
            <div className="process-step">
              <div className="process-step-number">
                <span>03</span>
              </div>
              <h4 className="process-step-title">Review</h4>
              <p className="section-content">
                Division engineers review requirements and response feasibility
                within 24 hours.
              </p>
            </div>
            <div className="process-step">
              <div className="process-step-number">
                <span>04</span>
              </div>
              <h4 className="process-step-title">Execution</h4>
              <p className="section-content">
                Project intake begins with a dedicated point of contact from the
                assigned division.
              </p>
            </div>
          </div>
          <div className="process-footer">
            <p className="section-content">
              <span>
                Typical response time:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="contact-access-text39">4-8 Business Hours</span>
              <span>. For urgent escalations, contact 800.STX.9111.</span>
            </p>
          </div>
        </div>
      </section>
      <section className="cta-grid-section">
        <div className="cta-grid-container">
          <div className="cta-grid-header">
            <h2 className="section-title">Division Portals</h2>
            <p className="section-subtitle">
              Access full services, case studies, and technical specifications
              for each operating company.
            </p>
          </div>
          <div className="cta-grid-items">
            <div className="cta-grid-item">
              <div className="cta-item-content">
                <h4 className="cta-item-title">General Contracting</h4>
                <a href="#">
                  <div className="btn-outline btn btn-sm">
                    <span>Enter Portal</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="cta-grid-item">
              <div className="cta-item-content">
                <h4 className="cta-item-title">Electrical Solutions</h4>
                <a href="#">
                  <div className="btn-outline btn btn-sm">
                    <span>Enter Portal</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="cta-grid-item">
              <div className="cta-item-content">
                <h4 className="cta-item-title">HVAC &amp; Mechanical</h4>
                <a href="#">
                  <div className="btn-outline btn btn-sm">
                    <span>Enter Portal</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="cta-grid-item">
              <div className="cta-item-content">
                <h4 className="cta-item-title">Roofing &amp; Building</h4>
                <a href="#">
                  <div className="btn-outline btn btn-sm">
                    <span>Enter Portal</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="cta-grid-item">
              <div className="cta-item-content">
                <h4 className="cta-item-title">Plumbing &amp; Piping</h4>
                <a href="#">
                  <div className="btn-outline btn btn-sm">
                    <span>Enter Portal</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="cta-grid-item">
              <div className="cta-item-content">
                <h4 className="cta-item-title">Civil Engineering</h4>
                <a href="#">
                  <div className="btn-outline btn btn-sm">
                    <span>Enter Portal</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <dialog id="inquiryModal" className="inquiry-dialog">
        <div className="modal-header">
          <h3 className="section-title">Division Inquiry</h3>
          <button id="closeModal" className="modal-close-btn">
            &amp;times;
          </button>
        </div>
        <form
          action="/submit-inquiry"
          method="POST"
          data-form-id="3f5a74f8-78be-4b30-91ee-97230d1dd000"
          className="inquiry-form"
        >
          <input
            type="hidden"
            id="formDivision"
            name="division"
            data-form-field-id="formDivision"
          />
          <div className="form-group">
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              id="name"
              name="true"
              required="true"
              placeholder="John Doe"
              data-form-field-id="name"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Work Email</label>
            <input
              type="email"
              id="email"
              name="email"
              required="true"
              placeholder="john@company.com"
              data-form-field-id="email"
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              required="true"
              placeholder="555-0123"
              data-form-field-id="phone"
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Project Brief</label>
            <textarea
              id="message"
              name="message"
              required="true"
              minlength="20"
              placeholder="Please provide a brief overview of your requirements..."
              data-form-field-id="message"
            ></textarea>
          </div>
          <div className="form-actions">
            <button
              id="thq_button_1TDS"
              name="button"
              type="submit"
              data-form-field-id="thq_button_1TDS"
              className="btn-lg btn btn-primary"
            >
              Submit Secure Inquiry
            </button>
          </div>
        </form>
      </dialog>
      <div className="contact-access-container2">
        <div className="contact-access-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
* {
  animation-duration: 0.01ms !important;
  animation-iteration-count: 1 !important;
  transition-duration: 0.01ms !important;
  scroll-behavior: auto !important;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="contact-access-container4">
        <div className="contact-access-container5">
          <Script
            html={`<script defer data-name="stratix-contact-logic">
(function(){
  const modal = document.getElementById('inquiryModal');
  const closeBtn = document.getElementById('closeModal');
  const formDivisionInput = document.getElementById('formDivision');
  const openButtons = document.querySelectorAll('.open-form-btn');

  openButtons.forEach(button => {
    button.addEventListener('click', () => {
      const divisionName = button.getAttribute('data-division');
      formDivisionInput.value = divisionName;
      modal.showModal();
    });
  });

  closeBtn.addEventListener('click', () => {
    modal.close();
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.close();
    }
  });

  // Handle form visual feedback (UX enhancement)
  const inquiryForm = document.querySelector('.inquiry-form');
  inquiryForm.addEventListener('submit', (e) => {
    // Native submission will occur, this is just for visual confirmation if needed
    // In a real scenario, you might show a loading state on the button
    const submitBtn = inquiryForm.querySelector('button[type="submit"]');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Processing...';
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default ContactAccess
